<template>
  <!-- Tabla de movimientos -->
  <v-data-table
    :headers="tabla.headers"
    :items="tabla.movimientos"
    :options.sync="tabla.options"
    :server-items-length="tabla.count"
    :fixed-header="true"
    class="elevation-3"
    calculate-widths
    :footer-props="{ itemsPerPageOptions: [5, 10, 20, 50], itemsPerPageText: $t('Registros por página') }"
  >
    <template v-slot:item="{ item }">
      <tr :class="item.cantidad < 0 ? 'red--text' : 'green--text text--darken-3'">
        <td>{{ item.created | moment('DD/MM/YYYY HH:mm') }}</td>
        <td v-if="show_column_producto">{{ item.producto.text }}</td>
        <td>{{ item.descripcion }}</td>
        <td>
          <span v-if="item.cantidad > 0">+</span>
          {{ item.cantidad }}
        </td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
export default {
  name: "TablaMovimientosStock",
  props: {
    // Filtros para realizar la búsqueda
    selected_filters: {
      type: Object,
      default: {},
      required: true
    },
    show_column_producto: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    // Variables para la tabla
    tabla: {
      movimientos: [],
      count: 0,
      headers: [],
      filtros: {},
      options: {
        itemsPerPage: localStorage.getItem('itemsPerPage') ? parseInt(localStorage.getItem('itemsPerPage')) :  10
      }
    }
  }),

  methods: {
    /**
     * Obtiene los movimientos de stock
     * @returns {Promise<void>}
     */
    async get_movimientos_stock() {
      let filtros = {...this.tabla.filtros, ...this.selected_filters}

      // Preparamos los filtros del buscador
      if(this.selected_filters['categoria'])
        filtros['producto__categoria__in'] = this.selected_filters['categoria'].join(",")
      if(this.selected_filters['producto__in'])
        filtros['producto__in'] = this.selected_filters['producto__in'].join(",")

      try {
        const response = await this.$store.dispatch("producto/get_movimientos_stock", {
          params: filtros
        });
        this.tabla.movimientos = response.results;
        this.tabla.count = response.count;

      } catch (err) {
	      this.$snotify.error(
		      this.$t("Ha ocurrido un error"),
		      this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
	      )
      }
    }
  },

  // Observamos el campo
  watch: {
    'tabla.options': {
      handler(value, oldValue){
        if(value.itemsPerPage !== oldValue.itemsPerPage){
          try{
            localStorage.setItem('itemsPerPage', value.itemsPerPage)
          }catch (e){}
        }
        this.tabla.filtros['limit'] = value.itemsPerPage
        this.tabla.filtros['offset'] = ((value.page - 1) * value.itemsPerPage)
        if (value.sortBy.length) {
          let desc = value.sortDesc[0] === true ? '-' : ''
          this.tabla.filtros['ordering'] = `${desc}${value.sortBy[0]
              .split(".")
              .join("__")}`;
        }
        this.get_movimientos_stock()
      },
    },
  },

  mounted() {
    let column_producto_class = "primary white--text"
    if(!this.show_column_producto)
      column_producto_class = "hidden"

    this.tabla.headers = [
      { text: this.$t("Fecha"), value: "created", class: "primary white--text"},
      { text: this.$t("Producto"), value: "producto__nombre", class: column_producto_class},
      { text: this.$t("Descripción"), value: "descripcion", class: "primary white--text", sortable: false},
      { text: this.$t("Cantidad"), value: "cantidad", class: "primary white--text", sortable: false}
    ]
  }
}
</script>

<style>
.hidden{
  display: none;
}
</style>
